import { FC } from 'react'
import { Route, Routes } from 'react-router-dom'

import ChatScreen from '../pages/Chat'

const ChatRouter: FC = () => {
  return (
    <Routes>
      <Route path="/" element={<ChatScreen />} />
      <Route path="/:userId" element={<ChatScreen />} />
    </Routes>
  )
}

export default ChatRouter
